import { render, staticRenderFns } from "./NewPagination.vue?vue&type=template&id=1795e7de&"
import script from "./NewPagination.vue?vue&type=script&lang=js&"
export * from "./NewPagination.vue?vue&type=script&lang=js&"
import style0 from "./NewPagination.vue?vue&type=style&index=0&id=1795e7de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports